const tintColorLight = "#529c8e";
const tintColorDark = "#4b8e7f";

export default {
  light: {
    text: "#000",
    background: "#fff",
    tint: tintColorLight,
    tabIconDefault: "#ccc",
    tabIconSelected: tintColorLight,
    light: "#bfbfbf",
    backgroundInput: "#F6F6F6",
    chatTheme: "#55A99D",
  },
  dark: {
    text: "#fff",
    background: "#000",
    tint: tintColorDark,
    tabIconDefault: "#ccc",
    tabIconSelected: tintColorDark,
    light: "#bfbfbf",
    backgroundInput: "#202c33",
    chatTheme: "#9f85fe",
  },
};
